import { html, ref, repeat, when } from '@microsoft/fast-element';
import { classNames } from '@microsoft/fast-web-utilities';
import { getPrefix } from '../utils';
import { mapType } from './filter-bar.utils';
const loadingTemplate = html `
  <p>Fetching metadata for ${(x) => x.resource}...</p>
`;
const collapseIcon = (prefix) => html `
  ${when((x) => x.collapsed, html `
      <${prefix}-icon name="chevron-up"></${prefix}-icon>
    `)}
  ${when((x) => !x.collapsed, html `
      <${prefix}-icon name="chevron-down"></${prefix}-icon>
    `)}
`;
export const filterBarTemplate = (prefix) => html `
  <div
    class=${(x) => classNames(['toggle', true], ['toggle-collapsed', x.collapsed])}
    @click="${(x) => x.toggle()}"
  >
    ${collapseIcon(prefix)}
  </div>
  <div class=${(x) => classNames(['filter-bar', true], ['collapsed', x.collapsed])}>
    <div class="filter-grid" ${ref('filterGrid')}>
      ${repeat((x) => x.fields, html `
          <${prefix}-filter
            label="${(x) => x.UI_LABEL}"
            target="${(x, c) => { var _a; return (_a = c.parent) === null || _a === void 0 ? void 0 : _a.target; }}"
            type="${(x) => mapType(x.TYPE)}"
            fieldName="${(x) => x.NAME}"
            enumOptions="${(x) => x.VALID_VALUES}"
          ></${prefix}-filter>
        `)}
    </div>
  </div>
`;
export const foundationFilterBarTemplate = html `
  ${(x) => (x.ready ? filterBarTemplate(getPrefix(x)) : loadingTemplate)}
`;
